var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 16.565,
    viewBox: "0 0 12 16.565",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2845",
    "data-name": "Group 2845",
    transform: "translate(4488 -3839.435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1195",
    "data-name": "Rectangle 1195",
    transform: "translate(-4488 3845)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 11,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.4,
    y: 0.4,
    width: 11.2,
    height: 10.2,
    rx: 0.6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1196",
    "data-name": "Rectangle 1196",
    width: 4,
    height: 2,
    transform: "translate(-4484 3844)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Back",
    transform: "translate(-4479 3840) rotate(90)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_26",
    "data-name": "Line 26",
    x2: 11,
    transform: "translate(1 3)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_27",
    "data-name": "Line 27",
    x2: 3,
    y2: 3,
    transform: "translate(0 3)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_32",
    "data-name": "Line 32",
    y1: 3,
    x2: 3,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.7896fd203c8b19cf382ae585554de7d0.svg";
export { ForwardRef as ReactComponent };